import React from 'react';
import { Link } from 'react-router-dom';
import { CloudRain, XCircle } from '@phosphor-icons/react';

const PaymentCancel = () => {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-slate-200 bg-white">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 py-4">
          <Link to="/dashboard" className="flex items-center gap-2">
            <CloudRain size={28} weight="bold" className="text-blue-600" />
            <span className="text-xl font-bold tracking-tight text-slate-950" style={{ fontFamily: 'Chivo' }}>WeatherProof</span>
          </Link>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 sm:px-6 py-16">
        <div className="text-center" data-testid="payment-cancelled">
          <XCircle size={64} weight="light" className="text-slate-300 mx-auto mb-6" />
          <h1 className="text-2xl font-bold text-slate-950 mb-2" style={{ fontFamily: 'Chivo' }}>Payment Cancelled</h1>
          <p className="text-sm text-slate-500 mb-8">No charges were made. You can return to your weather lookup and try again.</p>

          <div className="flex items-center justify-center gap-4">
            <Link
              to="/lookup"
              data-testid="return-to-lookup-btn"
              className="px-6 py-2 bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 transition-colors"
            >
              Back to Lookup
            </Link>
            <Link to="/dashboard" className="text-sm text-slate-600 hover:text-slate-950 font-medium">Dashboard</Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PaymentCancel;
